import type { RouteObject } from "react-router-dom";
import { FormsHomePage } from "./pages/FormsHomePage";
import { FormFamilyListPage } from "./pages/FormFamilyListPage";
import { FormFamilyCreatePage } from "./pages/FormFamilyCreatePage";
import { FormFamilyDetailPage } from "./pages/FormFamilyDetailPage";
import { FormRevisionEditorPage } from "./pages/FormRevisionEditorPage";
import { FormFillPage } from "./pages/FormFillPage";
import { FormInstanceListPage } from "./pages/FormInstanceListPage";
import { FormInstanceDetailPage } from "./pages/FormInstanceDetailPage";
import { CustomFieldsManagerPage } from "@/features/customFields/CustomFieldsManagerPage";
import { CustomFieldsHelpPage } from "./pages/help/CustomFieldsHelpPage";
import FormsHomeHelp from "./help/forms-home.mdx";
import FormFamilyListHelp from "./help/form-family-list.mdx";
import FormFamilyCreateHelp from "./help/form-family-create.mdx";
import FormFamilyDetailHelp from "./help/form-family-detail.mdx";
import FormRevisionEditorHelp from "./help/form-revision-editor.mdx";
import FormFillHelp from "./help/form-fill.mdx";
import FormInstanceListHelp from "./help/form-instance-list.mdx";
import FormInstanceDetailHelp from "./help/form-instance-detail.mdx";

/**
 * ADR-072 Rule FMS-01/FMS-03: این آرایه در router.tsx مرکزی spread میشود.
 * هیچ importی از features دیگر اینجا مجاز نیست.
 */
export const formsRoutes: RouteObject[] = [
  { path: "forms", element: <FormsHomePage /> },
  { path: "forms/families", element: <FormFamilyListPage /> },
  { path: "forms/families/create", element: <FormFamilyCreatePage /> },
  { path: "forms/families/:id", element: <FormFamilyDetailPage /> },
  { path: "forms/revisions/:id", element: <FormRevisionEditorPage /> },
  { path: "forms/fill/:revisionId", element: <FormFillPage /> },
  { path: "forms/instances", element: <FormInstanceListPage /> },
  { path: "forms/instances/:id", element: <FormInstanceDetailPage /> },
  { path: "forms/custom-fields", element: <CustomFieldsManagerPage /> },
  { path: "help/forms/custom-fields", element: <CustomFieldsHelpPage /> },
  { path: "help/forms/home", element: <FormsHomeHelp /> },
  { path: "help/forms/families", element: <FormFamilyListHelp /> },
  { path: "help/forms/families/create", element: <FormFamilyCreateHelp /> },
  { path: "help/forms/family-detail", element: <FormFamilyDetailHelp /> },
  { path: "help/forms/revision-editor", element: <FormRevisionEditorHelp /> },
  { path: "help/forms/form-fill", element: <FormFillHelp /> },
  { path: "help/forms/instances", element: <FormInstanceListHelp /> },
  { path: "help/forms/instance-detail", element: <FormInstanceDetailHelp /> },
];
